import { render } from "./parametros.vue?vue&type=template&id=638bfc45&scoped=true"
import script from "./parametros.vue?vue&type=script&lang=js"
export * from "./parametros.vue?vue&type=script&lang=js"

import "./parametros.vue?vue&type=style&index=0&id=638bfc45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638bfc45"]])

export default __exports__